import React, { useEffect, useState } from 'react';
import './reseller.css';
import api from '../../axiosInstance';
import { DataGrid } from '@mui/x-data-grid';
import { Button, IconButton, TextareaAutosize, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from "sweetalert2";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { useMediaQuery } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import VerifiedIcon from '@mui/icons-material/Verified';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import { useNavigate } from "react-router-dom";
import { nanoid } from 'nanoid';
import { CancelOutlined } from "@mui/icons-material";
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';


function Resellers() {
  const isMobile = useMediaQuery('(max-width:600px)');
  const navigate = useNavigate();
  const parent_id = sessionStorage.getItem('userid');



  const [formData, setFormData] = useState({
    parent_id,
    type: 1,
    name: '',
    password: '',
    email: '',
    email2: '',
    phone: '',
    phone2: '',
    address: '',
    bank_details: '',
    other_details: '',
  });

  const [resellers, setResellers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingReseller, setEditingReseller] = useState(null);
  const [page, setPage] = useState(1);
  const [resellerPage, setResellerPage] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uniqueLink, setUniqueLink] = useState()
  const [pending, setPending] = useState(false)


  useEffect(() => {
    fetchResellers(page);
  }, [page]);

  const fetchResellers = async () => {
    try {

      const response = await api.get(`/distributorchild/${parent_id}/1?page=${page}`);
      console.log("Response reselleer", response)
      if (response.status === 200) {
        const filteredlink = response.data.meta.links.filter(link => /^[0-9]+$/.test(link.label))
        const updatedfilteredlinks = filteredlink.map(link => ({
          ...link,
          active: parseInt(link.label) == page
        }))
        setResellerPage(updatedfilteredlinks)
        setResellers(response.data.data || []);
        console.log("reseller", response.data.data);
      }
    } catch (error) {
      console.error('Error fetching resellers:', error);
    }
  };

  console.log("reseller state", resellers)

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'radio' ? Number(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setPending(true)
      if (editingReseller) {
        // Extract only changed fields
        //const updatedData = {};
        const updatedData = { type: formData.type }; // Ensure `type` is always sent
        Object.keys(formData).forEach((key) => {
          if (formData[key] !== editingReseller[key]) {
            updatedData[key] = formData[key];
          }
        });

        if (Object.keys(updatedData).length === 0) {
          // alert("No changes detected.");
          Swal.fire("No changes detected", "", "info");
          return;
        }

        const response = await api.put(`/distributor/${editingReseller.id}`, updatedData);
        if (response.status === 200) {
          // alert('Reseller updated successfully!');
          Swal.fire("Success", "Reseller updated successfully!", "success");
          setPending(false)

        }
      } else {

        const cleanedFormData = Object.keys(formData).reduce((acc, key) => {
          if (formData[key] !== "" && formData[key] !== null && formData[key] !== undefined) {
            acc[key] = formData[key];
          }
          return acc;
        }, {});
        const response = await api.post('/distributor', cleanedFormData);

        if (response.status === 200) {
          // alert('Reseller added successfully!');

          Swal.fire("Success", "Reseller added successfully!", "success").then((result) => {
            if (result.isConfirmed) {
              resetForm();
              fetchResellers(page);
            }
          });
          setPending(false)
        }
      }

    } catch (error) {
      // console.log("error response",error?.response)
      // alert(`Error: ${error?.response?.data?.error}`);
      // console.error(error);
      setPending(false)
      if (error.response && error.response.data && error.response.data.errors) {
        const errors = error.response.data.errors || error.response.data;
        let errorMessages = Object.keys(errors)
          .map((field) => `${field}: ${errors[field].join(", ")}`)
          .join("<br>"); // Format errors with line breaks

        Swal.fire({
          title: "Validation Error",
          html: errorMessages,
          icon: "error",
        });
      } else {
        Swal.fire("Error", "An unexpected error occurred. Please try again.", "error");
      }
    }
  };

  const resetForm = () => {
    setFormData({
      parent_id,
      type: 1,
      name: '',
      password: '',
      email: '',
      email2: '',
      phone: '',
      phone2: '',
      address: '',
      bank_details: '',
      other_details: '',
    });
    setShowForm(false);
    setEditingReseller(null);
  };

  // const handleDelete = async (id) => {
  //   if (window.confirm("Are you sure you want to delete this?")) {
  //     try {
  //       await api.delete(`/distributor/${id}`);
  //       alert("Deleted successfully");
  //       fetchResellers();
  //     } catch (error) {
  //       console.error("Error:", error);
  //       alert("Something went wrong");
  //     }
  //   }
  // };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.delete(`/distributor/${id}`);
          Swal.fire("Deleted!", "The reseller has been deleted.", "success");
          fetchResellers();
        } catch (error) {
          console.error("Error:", error);
          Swal.fire("Error", "Something went wrong!", "error");
        }
      }
    });
  };


  const handleEdit = (reseller) => {
    setFormData({
      parent_id,
      type: 1,
      name: reseller.name,
      password: '',
      email: reseller.email,
      email2: reseller.email2,
      phone: reseller.phone,
      phone2: reseller.phone2,
      address: reseller.address,
      bank_details: reseller.bank_details,
      other_details: reseller.other_details,
    });
    setEditingReseller(reseller);
    setShowForm(true);
  };


  const handleEmailverification = async (reseller) => {
    if (!reseller?.email_verify_token) {
      // alert("Email verification token is missing.");
      Swal.fire("Error", "Email verification token is missing.", "error");

      return;
    }

    try {
      const response = await api.get(`/verifyemail/${reseller?.email_verify_token}`);

      if (response.status === 200) {
        // alert("Email verification successful!");
        Swal.fire("Success", "Email verification successful!", "success");

        fetchResellers(page); // Refresh the list to reflect changes
      } else {
        // alert("Failed to verify email. Please try again.");
        Swal.fire("Error", "Failed to verify email. Please try again.", "error");

      }
    } catch (error) {
      console.error("Error verifying email:", error);
      // alert(error.response?.data?.message || "Something went wrong.");
      Swal.fire("Error", error.response?.data?.message || "Something went wrong.", "error");

    }
  };

  const handlePageChange = (newPage) => {

    // setPage(newPage);
    if (newPage !== page) {
      setPage(newPage);
    }

  };


  const CustomPagination = () => (
    <>
      <div className='d-flex justify-content-center'>
        <Button
          size="small"
          variant="contained"
          onClick={() => handlePageChange(page - 1)}
          disabled={page === 1}
          sx={{ padding: "2px 6px", minWidth: "30px" }} // Reduced padding

        // sx={{ marginRight: 2 }}
        >
          {/* Previous */}
          <ArrowBack fontSize="small" />

        </Button>


        {(resellerPage?.length > 0 ? resellerPage : [{ label: "1", active: true }, { label: "2", active: false }]).map((link, index) => (
          <Button
            size="small"
            key={index}
            variant={link.active ? "contained" : "outlined"}
            color={link.active ? "primary" : "default"}
            onClick={() => handlePageChange(parseInt(link.label))}
            sx={{ marginX: "2px", padding: "2px 6px", minWidth: "30px", marginLeft: 1 }}
          >
            {link.label}
          </Button>
        ))}
        <Button
          size="small"
          variant="contained"
          onClick={() => handlePageChange(page + 1)}
          disabled={resellerPage.length === 0 || page >= resellerPage.length}
          sx={{ padding: "2px 6px", minWidth: "30px", marginLeft: 1 }} // Reduced padding

        // sx={{ marginLeft: 2 }}
        >
          {/* Next */}
          <ArrowForward fontSize="small" />

        </Button>
      </div>
    </>
  );

  const resellerGenerate = () => {
    const id = nanoid(10)
    const disturbid = sessionStorage.getItem("userid")
    const generatelink = `${window.location.origin}/sharedisturbutor/${disturbid}/1/${id}`
    setUniqueLink(generatelink)

  }

  const handleCancel = () => {
    setUniqueLink("")
  }


  const resellerLink = (params) => {
    console.log("sendDistink", params.row.parent_id)
    const token = sessionStorage.getItem("Authorization");
    const email = sessionStorage.getItem("email")
    const disturblink = `${window.location.origin}/editdisturbutor?parentid=${params.row.parent_id}&email=${email}&disid=${params.row.id}&type=${1}&token=${token}`
    // setCopiedLink(clientlink)
    console.log("clientlink", disturblink)
    setUniqueLink(disturblink)


  }


  const rowsWithIndex = resellers.map((item, index) => ({
    ...item,
    idindex: index + 1, // start index from 1
  }));

  return (

    <div className='row ' style={{ height: "100%" }}>
      <div className='col-md-12 col-12 ' style={{ position: "relative" }}>
        <div className=" d-flex flex-warp justify-content-between align-items-center p-2">
          <h3 className='distributerfont'>Resellers</h3>
          <div className='d-flex flex-column flex-md-row justify-content-center align-items-center'>
            {uniqueLink ? (
              <>
                <div className='d-flex flex-wrap justify-content-center align-items-center '>
                  <TextareaAutosize style={{ minWidth: "450px", padding: "0.2rem" }} value={uniqueLink} />

                  <IconButton>
                    <CancelOutlined onClick={handleCancel} />
                  </IconButton>
                </div>

              </>
            )
              :
              (
                <button className='reseller-generate' onClick={resellerGenerate}>Generate links</button>
              )

            }

            <button
              type="button"
              className="rounded btnproduct m-1"
              onClick={() => {
                resetForm(); // Clear form data
                setShowForm(!showForm); // Toggle form visibility
              }}
            >
              {showForm ? 'List Reseller' : 'Add Reseller'}
            </button>
          </div>


        </div>
        {showForm ? (
          <div className='distributerbgimage rounded-3 shadow d-flex justify-content-center align-items-center'>
            <div className='formwidthBgImage py-1 px-5 m-3 shadow rounded-5'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                  {[
                    { label: 'Name', name: 'name', type: 'text', required: true },
                    { label: 'Password', name: 'password', type: 'password' },
                    { label: 'Primary Mail (UserName)', name: 'email', type: 'email' },
                    { label: 'Secondary Mail', name: 'email2', type: 'email' },
                    { label: 'Phone Number 1', name: 'phone', type: 'text' },
                    { label: 'Phone Number 2', name: 'phone2', type: 'text' },
                  ].map((field) => (
                    <div key={field.name} className='col-md-6 col-12 mb-3'>
                      <label htmlFor={field.name} className='form-label'>{field.label}</label>
                      <input
                        className='form-control'
                        name={field.name}
                        type={field.type}
                        placeholder={field.label}
                        value={formData[field.name]}
                        onChange={handleChange}
                        required={field.required}
                      />
                    </div>
                  ))}
                  {[
                    { label: 'Address', name: 'address' },
                    { label: 'Bank Details', name: 'bank_details' },
                    { label: 'Other Details', name: 'other_details' },
                  ].map((field) => (
                    <div key={field.name} className='col-md-6 col-12 mb-3'>
                      <label htmlFor={field.name} className='form-label'>{field.label}</label>
                      <textarea
                        className='form-control'
                        placeholder={field.label}
                        name={field.name}
                        value={formData[field.name]}
                        onChange={handleChange}
                      />
                    </div>
                  ))}
                </div>
                <div className='d-flex justify-content-end'>
                  <button type='reset' className='btn btn-secondary m-1' onClick={resetForm}>Cancel</button>
                  <button type='submit' disabled={pending} className='btn btn-primary m-1'>{editingReseller ? 'Update' : 'Submit'}</button>
                </div>
              </form>
            </div>
          </div>
        ) : (
          //             <div className='distributerbgimage divheight rounded-3 shadow d-flex justify-content-center align-items-start'>
          //               <div className='formwidthBgImage py-1 px-5 m-3 shadow rounded-5'>
          //                 {resellers.length > 0 ? (
          //                   <table className='table table-striped rounded-3 shadow'>
          //                     <thead>
          //                       <tr>
          //                         <th>#</th>
          //                         <th>Name</th>
          //                         <th>Email</th>
          //                         <th>Phone</th>
          //                         <th>Action</th>
          //                       </tr>
          //                     </thead>
          //                     <tbody>
          //                       {resellers?.filter((filter)=>filter.type == 1)?.map((reseller, index) => (
          //                         <tr key={reseller.id}>
          //                           <td>{index + 1}</td>
          //                           <td>{reseller.name}</td>
          //                           <td>{reseller.email}</td>
          //                           <td>{reseller.phone}</td>
          //                           <td>
          //                           <button
          //   type="button"
          //   className="border-0 m-2"
          //   onClick={(event) => {
          //     event.preventDefault();
          //     if (reseller?.email_verify_status === 0) {
          //       handleEmailverification(reseller);
          //     }
          //   }}
          // >
          //   {reseller?.email_verify_status === 0 ? (
          //     <i className="bi bi-envelope-exclamation text-danger icons-style"></i>
          //   ) : (
          //     <i className="bi bi-envelope-check text-success icons-style"></i>
          //   )}
          // </button>


          //                             <button type="button" className="border-0 m-2" onClick={(e) => { e.preventDefault(); handleEdit(reseller); }}>
          //                               <i className="bi bi-pencil-square icolor icons-style"></i>
          //                             </button>
          //                             <button type="button" className="border-0 m-2" onClick={(e) => { e.preventDefault(); handleDelete(reseller.id); }}>
          //                               <i className="bi bi-trash-fill icolor icons-style"></i>
          //                             </button>
          //                           </td>
          //                         </tr>
          //                       ))}
          //                     </tbody>
          //                   </table>
          //                 ) : (
          //                   <p>No resellers found.</p>
          //                 )}
          //               </div>
          //             </div>

          <>
            <div style={{ height: "24rem", width: "100%" }}>
              <DataGrid
                rows={rowsWithIndex}
                columns={[
                  { field: 'idindex', headerName: '#', width: 70 },
                  { field: 'name', headerName: 'Name', width: 150 },
                  { field: 'email', headerName: 'Email', width: 200 },
                  { field: 'phone', headerName: 'Phone', width: 150 },
                  {
                    field: 'emailStatus', headerName: 'Email Status', width: 150, renderCell: (params) => (
                      <>
                        <IconButton>
                          {params.row.email_verify_status === 0 ? <EmailIcon sx={{ color: "red" }} /> : <VerifiedIcon sx={{ color: "green" }} />}
                        </IconButton>
                      </>
                    )
                  },
                  {
                    field: 'actions',
                    headerName: 'Actions',
                    width: 250,
                    renderCell: (params) => (
                      <>
                        <div className='d-flex justify-content-center align-items-center h-100 gap-4'>
                          {/* <IconButton onClick={() => navigate(`/order/${params.row.parent_id}/${params.row.id}`)}>
                            <AddCircleRoundedIcon />
                          </IconButton> */}
                          <Tooltip title="Add Product">
                            <IconButton onClick={() => navigate(`/distributerproduct/${params.row.id}`)}>
                              {/* <PriceChangeIcon /> */}
                              <AddShoppingCartIcon style={{ color: 'black' }} />
                            </IconButton>
                          </Tooltip>

                          {/* <IconButton 
                              color={params.row.email_verify_status === 0 ? 'error' : 'success'} 
                              onClick={() => {
                                if (params.row.email_verify_status === 0) handleEmailverification(params.row);
                              }}
                            >
                              {params.row.email_verify_status === 0 ?  <VerifiedIcon />:<EmailIcon /> }
                            </IconButton> */}


                          <button className='reseller_send' onClick={() => resellerLink(params)}>Send link</button>





                          {/* <IconButton color="primary" onClick={() => handleEdit(params.row)}>
                              <EditIcon />
                            </IconButton> */}
                          {/* <IconButton color="secondary" onClick={() => handleDelete(params.row.id)}>
                              <DeleteIcon />
                             </IconButton>  */}
                        </div>
                      </>
                    ),
                  },
                ]}
                loading={loading}
                pagination={false}
                hideFooter
              />

            </div>
            <div className={isMobile ? 'pagination-mobile' : 'pagination-content'}>
              <CustomPagination />
            </div>
          </>
        )}
        {/* Sidebar */}



      </div>
      {/* <div className='col-md-3 col-12 distributerSideimage rounded-5 mt-md-0 mt-2'>
        <div className='bg-white my-4 mx-2 p-3 rounded-5 shadow'>
          <h5>Details</h5>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam praesentium vel harum tempore eaque asperiores? Delectus voluptatum eligendi tempore fugit labore, officiis reiciendis, deserunt sunt cupiditate, minus sed omnis eveniet.</p>
        </div>
      </div> */}
    </div>


  );
}


export default Resellers;
